import React, { useState, useEffect } from 'react';
import axiosInstance from 'pages/Utility/axiosInstance';
import Breadcrumb from 'components/Common/Breadcrumb2';
import ExtentionTable from './ExtentionsTable';

const ExtentionsList = () => {
    const [extentionOrders, setExtentionOrders] = useState()
    const [loading, setLoading] = useState(false);

    const fetchExtentionOrders = async () => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('', { params: { sp: "usp_GetPendingWorkOrderExtension" } });
            setExtentionOrders(response?.data?.Data)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchExtentionOrders();
    }, [])

    return (
        <>
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center ms-3">
                    <Breadcrumb title="Extensions" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Extentions", link: '#' }]} />
                </div>
                <ExtentionTable
                    List={extentionOrders}
                    loading={loading}
                    handleSubmit={fetchExtentionOrders}
                />
            </div>
        </>
    );
};

export default ExtentionsList;
